module.exports = __webpack_public_path__ + "static/media/activityCover@3x.22bab1e3.png";